<template>
    <div>
        <div class="product-reviews flex-column mb-0">
            <div v-if="!logged || (this.isExistUserOrderItem && !this.isExistUserReview && this.isProductAvailable)" class="product-reviews-header">
                <p class="mb-3">Поделитесь своим мнением о товаре, чтобы помочь другим покупателям сделать правильный выбор.</p>
                <span class="btn btn-outline" @click.prevent="onClickAddButton" >Оставить отзыв</span>
            </div>
            <div v-if="logged && this.isExistUserOrderItem && this.isExistUserReview" class="product-reviews-header">
                <p class="mb-3">Вы уже оставили отзыв на данный товар.</p>
            </div>
            <div v-if="logged && !this.isExistUserOrderItem" class="product-reviews-header">
                <p class="mb-3">Отзыв можно оставить после получения товара.</p>
            </div>
            <div v-for="review in displayReviews" class="testimonial-item" itemprop="review" itemscope itemtype="https://schema.org/Review">
                <div class="testimonial-item-header">
                    <div class="testimonial-item-header-icon">{{ review.author.charAt(0).toUpperCase() }}</div>
                    <div class="testimonial-item-header-block testimonial-item-header-block--author">
                        <span itemprop="author" itemscope="" itemtype="https://schema.org/Person">
                            <span class="name" itemprop="name">{{ review.author }}</span>
                        </span>
                        <span>
                            <span itemprop="datePublished" class="date">{{ review.posted_at }}</span>
                            <span v-if="review.city" class="city">{{ review.city }}</span>
                        </span>
                    </div>
                    <div class="testimonial-item-header-block ml-0 ml-sm-auto mt-3 mb-3 product-rating">
                        <div class="product-rating-stars">
                            <span v-for="i in 5" :key="`rating-${i}`" class="star icon"
                                :class="{
                                    'fill': i <= Math.round(review.rating)
                                }"></span>
                        </div>
                    </div>
                </div>
                <div class="testimonial-item-content">
                    <div itemprop="description" class="testimonial-item-content-text">{{ review.text }}</div>
                </div>
            </div>
        </div>
        <a v-if="!displayAll && (reviews.length > 5)" href="#" class="link mt-3" @click.prevent="displayAll = true">Показать все</a>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import Pagination from "../Pagination";

    export default {
        name: 'ProductReviews',
        props: {
            id: {
                type: Number,
                required: true,
            },
            existUserReview: Boolean,
            existUserOrderItem: Boolean
        },
        components: {
            Pagination,
        },
        data: function () {
            return {
                perPage: 10,
                page: 1,
                displayAll: false,
            };
        },
        mounted() {
            if (window.location.hash.substr(1) === 'addReview'
                && this.logged
                && this.isExistUserOrderItem
                && !this.isExistUserReview
                && this.isProductAvailable)
            {
                this.$root.toggle('product-info-testimonials');

                this.$nextTick(function () {
                    document.getElementsByClassName('product-reviews')[0].scrollIntoView({
                        behavior: 'smooth',
                    });
                })

                this.openFeedbackModal('review');
            }

            this.setExistUserOrderItem(this.existUserOrderItem);
            this.setExistUserReview(this.existUserReview);
        },
        watch: {
            page (newValue, oldValue) {
                let elements = document.getElementsByClassName('product-review-item');

                if (elements.length) {
                    elements[0].scrollIntoView({
                        behavior: 'smooth',
                    });
                }
            }
        },
        methods: {
            ...mapMutations('auth', {
                showAuthModal: 'showModal',
                stayOnPageAfterAuth: 'stayOnPageAfterAuth'
            }),

            ...mapMutations('product', [
                'openFeedbackModal',
                'setExistUserOrderItem',
                'setExistUserReview',
            ]),

            onClickAddButton () {
                if (!this.logged) {
                    this.stayOnPageAfterAuth('addReview');

                    this.showAuthModal();
                } else {
                    if (this.isExistUserOrderItem && !this.isExistUserReview && this.isProductAvailable) {
                        this.openFeedbackModal('review');
                    }
                }
            },

            setPage (page) {
                this.page = page;
            }
        },
        computed: {
            ...mapState('auth', [
                'logged',
            ]),
            ...mapState('product', [
                'product',
                'reviews',
            ]),
            reviewsPage () {
                return this.reviews.slice(
                    this.perPage * (this.page - 1),
                    this.perPage * this.page - 1
                );
            },
            count () {
                return this.reviews.length;
            },
            hasReviews () {
                return this.count !== 0;
            },
            average () {
                return this.hasReviews ? _.round(_.sumBy(this.reviews, 'rating') / this.count, 1) : null;
            },
            totalPages () {
                return Math.ceil(this.reviews.length / this.perPage);
            },
            displayReviews () {
                return this.displayAll
                    ? this.reviews
                    : this.reviews.slice(0, 5);
            },
            isExistUserOrderItem () {
                return this.$store.state.product.existUserOrderItem;
            },
            isExistUserReview () {
                return this.$store.state.product.existUserReview;
            },
            isProductAvailable () {
                return this.$store.state.product.product.status === 1;
            }
        }
    }
</script>
